import React from 'react';
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '../ui/alert-dialog';

interface ConfirmDeleteDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onConfirm: () => void;
    title?: string;
    description?: string;
    isDeleting?: boolean;
    confirmLabel?: string;
    busyLabel?: string;
    confirmClassName?: string;
    /** Da usare quando la conferma si apre sopra una finestra flottante
     *  (livello 80): senza, resterebbe nascosta dietro. */
    isAboveFloatingWindow?: boolean;
}

export function ConfirmDeleteDialog({
    open,
    onOpenChange,
    onConfirm,
    title = "Sei sicuro?",
    description = "Questa azione non può essere annullata. L'elemento verrà eliminato definitivamente.",
    isDeleting = false,
    confirmLabel = "Elimina",
    busyLabel = "Eliminazione...",
    confirmClassName = "bg-red-600 hover:bg-red-700",
    isAboveFloatingWindow = false
}: ConfirmDeleteDialogProps) {
    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent
                className={isAboveFloatingWindow ? 'z-[90]' : undefined}
                overlayClassName={isAboveFloatingWindow ? 'z-[90]' : undefined}
            >
                <AlertDialogHeader>
                    <AlertDialogTitle>{title}</AlertDialogTitle>
                    <AlertDialogDescription>
                        {description}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel disabled={isDeleting}>Annulla</AlertDialogCancel>
                    <AlertDialogAction
                        onClick={(e) => {
                            e.preventDefault();
                            onConfirm();
                        }}
                        className={confirmClassName}
                        disabled={isDeleting}
                    >
                        {isDeleting ? busyLabel : confirmLabel}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
